import { useEffect, useState } from "react";
import { useServices } from "../app/context.js";
import { PRODUCT_CATEGORIES } from "./catalogOptions.js";

export interface ProductCategory { value: string; label: string }

/**
 * The Category choices of the template editor and the wizard: the catalog's active product
 * types, the same list the Generate page offers (owner, 2026-10-06: the two lists differed).
 * The fixed list stands in until the catalog answers, and when it cannot be read. `current`
 * stays selectable when the catalog no longer lists it, so an older template keeps its value.
 */
export function useProductCategories(current?: string): readonly ProductCategory[] {
  const { client } = useServices();
  const [types, setTypes] = useState<readonly ProductCategory[] | null>(null);
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const listed = (await client.templateOptions()).product_types ?? [];
        if (!cancelled && listed.length) setTypes(listed.map((t) => ({ value: t.code, label: t.label })));
      } catch { /* the fixed list stays */ }
    })();
    return () => { cancelled = true; };
  }, [client]);
  const list = types ?? PRODUCT_CATEGORIES;
  if (!current || list.some((c) => c.value === current)) return list;
  const known = PRODUCT_CATEGORIES.find((c) => c.value === current);
  return [...list, known ?? { value: current, label: current }];
}
